import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "src/@/components/ui/dialog";
import { Button } from "src/@/components/ui/button";
import { Input } from "src/@/components/ui/input";
import { Label } from "src/@/components/ui/label";
import { Textarea } from "src/@/components/ui/textarea";
import { Switch } from "src/@/components/ui/switch";

export default function ModalOrigins({ 
  open, 
  onClose, 
  onSubmit, 
  action, 
  nome, 
  descricao,
  ativo,
  changeNome, 
  changeDescricao,
  changeAtivo 
}) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>
            {action === "Criar" ? "Criar Origem de Contato" : "Editar Origem de Contato"}
          </DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid gap-2">
            <Label htmlFor="nome">Nome *</Label>
            <Input
              id="nome"
              value={nome || ''}
              onChange={changeNome}
              placeholder="Digite o nome da origem"
              required
            />
          </div>

        </div>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onClose}>
            Cancelar
          </Button>
          <Button onClick={onSubmit}>
            {action === "Criar" ? "Criar" : "Salvar"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
